import { render, staticRenderFns } from "./BalanceRecord.vue?vue&type=template&id=bc755968&scoped=true"
import script from "./BalanceRecord.vue?vue&type=script&lang=js"
export * from "./BalanceRecord.vue?vue&type=script&lang=js"
import style0 from "./BalanceRecord.vue?vue&type=style&index=0&id=bc755968&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc755968",
  null
  
)

export default component.exports